function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.8V17c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2h10v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V9.8c0-.3 0-.5-.1-.8h.6c.3 0 .5-.2.5-.5V8c0-.6-.4-1-1-1h-.8l-.9-2.1c-.2-.5-.7-1-1.2-1.1-1.2-.3-3.4-.8-6.1-.8-2.7 0-4.9.5-6.1.7-.6.1-1 .6-1.2 1.1L1.8 7H1c-.6 0-1 .4-1 1v.5c0 .3.2.5.5.5h.6c-.1.3-.1.5-.1.8zm2.7-2 .7-1.7c.1-.2.2-.4.4-.4C5.4 5.4 7 5 10 5s4.6.4 5.2.7c.2.1.4.2.4.4l.7 1.7c.1.2 0 .5-.2.6-.8.2-2.5.6-6.1.6-3.6 0-5.3-.4-6.1-.6-.2-.1-.3-.4-.2-.6zm9.3 3.5c0-.2.1-.3.3-.3l3.1-.8c.3-.1.6.2.6.5v.3c0 .6-.4 1-1 1h-2.3c-.4 0-.7-.3-.7-.7zm-10-.7c0-.3.3-.6.6-.5l3.1.8c.2.1.3.2.3.4 0 .4-.3.7-.7.7H4c-.6 0-1-.4-1-1v-.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgCar;